// Drops the focus a mouse click leaves behind inside the element.
//
// Bulma opens a .is-hoverable dropdown on :focus-within as well as :hover, and the menu items are
// router-links, so they are real focusable <a href> elements. Without this the focus left by the
// click keeps the dropdown open after the page has navigated away. See PCK-802.
export default {

  bind(el) {

    el.addEventListener('click', function (e) {
      // A click synthesised by Enter/Space has a detail of 0. Only a pointer click should drop the
      // focus, otherwise a keyboard user loses their place in the menu.
      if (e.detail === 0) return

      const focused = document.activeElement
      if (focused && el.contains(focused) && typeof focused.blur === 'function') {
        focused.blur()
      }
    })
  }
}
